import React from 'react';
import { useVisibleMagneticWallItemIds } from '../../../../../post/useVisibleMagneticWallItems';
import { CREATION_ID, EditorActions } from '../../../../editorSlice';
import { useQuill } from '../../../../QuillContext';
import { commentIcon } from '../../../editorIcons';
import ToolbarButton from '../ToolbarButton';
import selectBlotAndWaitMagneticWallUpdate from './selectBlotAndWaitMagneticWallUpdate';
import { useAppDispatch } from '../../../../../app/redux/useAppSelector';
import type { Blot } from '../../../../types';

interface ToolbarCommentButtonProps {
  existingComment?: string[] | null;
  blot?: Blot;
  onClick?: () => void;
}

const ToolbarCommentButton = ({
  existingComment,
  blot,
  onClick,
}: ToolbarCommentButtonProps) => {
  const visibleItemIds = useVisibleMagneticWallItemIds();
  const dispatch = useAppDispatch();
  const { quill } = useQuill();

  const visibleCommentIds = existingComment
    ? existingComment.filter((id) => visibleItemIds.has(`comment-${id}`))
    : [];

  return (
    <ToolbarButton
      icon={commentIcon}
      tooltip="Comment"
      shortcut="Ctrl + Alt + m"
      active={visibleCommentIds.length > 0}
      onClick={async () => {
        onClick?.();

        const firstVisibleCommentId = visibleCommentIds[0];
        if (firstVisibleCommentId) {
          dispatch(
            EditorActions.focusMagneticWall({
              id: firstVisibleCommentId,
              type: 'comment',
              isActive: true,
              hasExpandIntent: false,
            }),
          );
          return;
        }

        if (blot) {
          await selectBlotAndWaitMagneticWallUpdate(blot);
        }
        if (quill) {
          quill.root.blur(); // blur so that the comment input can get focus
        }

        dispatch(
          EditorActions.focusMagneticWall({
            id: CREATION_ID,
            type: 'comment',
            isActive: true,
            hasExpandIntent: false,
          }),
        );
      }}
    />
  );
};

export default ToolbarCommentButton;
